/*
 * @Author: v_smwang
 * @Date: 2020-07-24 18:48:27
 * @LastEditors: v_hllhe
 * @LastEditTime: 2022-12-29 17:30:36
 * @FilePath: \src\config\routerMap.js
 * @Description: 描述
 * @Module: 模块路径
 */
import PageView from '@/components/PageView';
import BasicLayout from '@/components/BasicLayout';

/**
 * 动态路由，根据用户角色动态过滤路由
 * @type { *[] }
 */
export const DYNAMIC_ROUTES = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: '/personnel-portrait',
    children: [
      {
        path: '/personnel-portrait',
        name: 'personnel-portrait',
        component: PageView,
        meta: { title: '人员画像', icon: 'table', roles: ['1001'] },
        children: [
          {
            path: '/personnel-portrait/personnel-portrait-overview',
            name: 'personnel-portrait-overview',
            component: () => import(
                '@/views/personnel-portrait/personnel-portrait-overview/index'
              ),
            meta: { title: '人员画像概览', keepAlive: true, roles: ['100101'] },
          },
          {
            path: '/personnel-portrait/personnel-portrait-details',
            name: 'personnel-portrait-details',
            component: () => import(
                '@/views/personnel-portrait/personnel-portrait-details/index'
              ),
            meta: { title: '人员画像详情', keepAlive: true, roles: ['100102'] },
          },
        ],
      },
      {
        path: '/personnel-workhour',
        name: 'personnel-workhour',
        component: PageView,
        meta: { title: '人员工时', icon: 'table', roles: ['1002'] },
        children: [
          {
            path: '/personnel-workhour/personnel-workhour-overview',
            name: 'personnel-workhour-overview',
            component: () => import(
                '@/views/personnel-workhourRemake/overview'
              ),
            meta: { title: '人员整体达标概览', keepAlive: true, roles: ['100201'] },
          },
          {
            path: '/personnel-workhour/personnel-workhour-overview/OverallcomplianceDetail',
            name: 'OverallcomplianceDetail',
            hidden: true,
            component: () => import(
              '@/views/personnel-workhourRemake/OverallcomplianceDetail/OverallcomplianceDetail'
              ),
            meta: { title: '人员整体达标率详情页', keepAlive: true, roles: ['100201'] },
          },
          {
            path: '/personnel-workhour/personnel-workhour-overview/Abnormal',
            name: 'Abnormal',
            hidden: true,
            component: () => import(
              '@/views/personnel-workhourRemake/Abnormal/Abnormal'
              ),
            meta: { title: '人员异常原因详情', keepAlive: true, roles: ['100201'] },
          },
          {
            path: '/personnel-workhour/personnel-workhour-detail',
            name: 'personnel-workhour',
            component: () => import(
                '@/views/personnel-workhourRemake/workhourDetail'
              ),
            meta: { title: '人员有效工时详情', keepAlive: true, roles: ['100202'] },
          },
          {
            path: '/personnel-workhour/personnel-workhour-check-productionline',
            name: 'personnel-workhour-checkProductionLine',
            component: () => import(
                '@/views/personnel-workhourRemake/CheckProductionLine'
              ),
            meta: { title: '人员有效工时审核', keepAlive: true, roles: ['10020301'] },
          },
          {
            path: '/personnel-workhour/personnel-workhour-check',
            name: 'personnel-workhour-checkSupplier',
            component: () => import(
                '@/views/personnel-workhourRemake/Check'
              ),
            meta: { title: '人员异常工时登记', keepAlive: true, roles: ['10020302'] },
          },
        ],
      },
      // {
      //   path: '/personnel-workhour',
      //   name: 'personnel-workhour',
      //   component: PageView,
      //   meta: { title: '人员工时', icon: 'table', roles: ['1002'] },
      //   children: [
      //     {
      //       path: '/personnel-workhour/personnel-workhour-overview',
      //       name: 'personnel-workhour-overview',
      //       component: () =>
      //         import(
      //           '@/views/personnel-workhour/personnel-workhour-overview/index'
      //         ),
      //       meta: { title: '人员工时概览', keepAlive: true, roles: ['100201'] }
      //     },
      //     {
      //       path: '/personnel-workhour/personnel-workhour-detail',
      //       name: 'personnel-workhour',
      //       component: () =>
      //         import(
      //           '@/views/personnel-workhour/personnel-workhour-detail/index'
      //         ),
      //       meta: { title: '人员工时详情', keepAlive: true, roles: ['100202'] }
      //     }
      //   ]
      // },
      {
        path: '/test',
        name: 'test',
        component: () => import('@/views/test/index'),
        meta: { title: '测试', keepAlive: true, roles: ['9999'] },
      },
      {
        path: '',
        component: () => import(
          '@/views/personnel-portrait/personnel-portrait-overview/index'
        ),
        meta: { title: '供应商人员画像大屏' },
      },
    ],
  },
  {
    path: '*',
    redirect: '/600',
    hidden: true,
  },
  // 人员看板
  {
    path: '/personnel-large',
    name: 'personnel-large',
    component: () => import('@/views/personnel-large'),
  },
  // 测试页面
  // {
  //   path: '/personnel-large/test',
  //   name: 'personnel-large/test',
  //   component: () => import('@/views/personnel-large/personnel-general/numGif'),
  //   // component: () => import('@/views/personnel-large/personnel-general/test'),
  // },
];

/**
 * 基础路由
 * @type { *[] }
 */
export const BASIC_MAP = [
  {
    path: '/404',
    name: '404',
    component: () => import('@/components/Exception/404'),
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/components/Exception/403'),
  },
  {
    path: '/600',
    name: '600',
    component: () => import('@/components/Exception/600'),
  },
  {
    path: '/table',
    name: 'table',
    component: () => import('@/views/personnel-portrait/personnel-portrait-overview/table/zongHeGaiLan.vue'),
  },
];
